/* eslint no-self-compare: 0, no-extend-native: 0*/
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

if (!Array.prototype.fill) {
  require('./polyfills/array-fill');
}

// HACK: check if @babel/polyfill is loaded before requiring this module.
// It should not be reloaded.
if (!window._babelPolyfill) {
  require('@babel/polyfill');
}

// Rejection tracking prevents a common issue where React gets into an
// inconsistent state due to an error, but it gets swallowed by a Promise,
// and the user has no idea what causes React's erratic future behavior.
// require('promise/lib/rejection-tracking').enable();

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
if (Object.assign === undefined) {
  Object.assign = require('object-assign');
}

if (typeof CustomEvent === 'undefined') {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    let evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = global.Event.prototype;
  global.CustomEvent = CustomEvent;
}

